import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
  Box,
  Button, Grid,
  TextField, Typography
} from '@material-ui/core';
import { setMainBook as apiSetMainBook } from '../../services/api';
import { autoComplete } from '../../services/main_book';
import EntitySelector from '../general/entity_selector/EntitySelector';

const MainBookEditor = ({ book, userStore }) => {
  const [mainBook, setMainBook] = useState(book.main_book);
  const [editing, setEditing] = useState(false);

  const getLabel = (book) => {
    if (!book) {
      return '';
    }

    return `ID ${book.id} - ${book.title} - ${book.authors}  - ISBN ${book.isbn13}`;
  };

  const enableEditing = () => {
    setEditing(true);
  };

  if (!editing) {
    return (
      <div>
        <TextField
          sx={{ width: 210 }}
          label='Livro-pai'
          type='text'
          color='success'
          focused
          size='small'
          InputLabelProps={{ shrink: true }}
          value={getLabel(mainBook)}
          disabled
          onClick={enableEditing}
        />
        <Button
          size='large'
          type='button'
          onClick={enableEditing}
        >
          Editar
        </Button>
      </div>
    );
  }

  return (
    <EntitySelector label='Livro-pai'
                    onChange={async (inputValue) => autoComplete(inputValue, userStore)}
                    onSave={async (selectedItem) => {
                      await apiSetMainBook(book.book_id, selectedItem?.id, userStore.token);
                    }}
                    onSaveSuccess={(item) => {
                      setEditing(false);
                      setMainBook(item);
                    }}
                    onCancel={() => setEditing(false)}
                    renderSelectedLabel={(item) => getLabel(item)}
                    renderOption={(b) => {
                      return (
                        <Grid container spacing={2} sx={{alignItems: 'center'}} key={b.id}>
                          <Grid item>
                          {b.cover_url && b.cover_url !== '' && (
                            <img alt={b.title} src={b.cover_url} style={{ width: 100 }} />)}
                          </Grid>
                          <Grid item sx={{alignItems: 'flex-start'}}>
                            <Typography sx={{textAlign: 'left'}}>
                              <b>{b.title}</b>
                              <br /> {b.authors}
                              <br /> {b.language}
                              <br /> ID {b.id}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    }}
    />
  );
};

export default MainBookEditor;
